export const queryKeys = {
  DIRECTION_BY_NAME: 'direction_by_name'
};
